// Stolen from x-parks. Perhaps it's time to pull in a standard library

export function getPoint(poly, t) {
    let sum = 0
    poly.forEach((coeff, pow) => {
        sum += coeff * t ** pow
    })

    return sum
}

export function getDerivative(poly) {
    return poly.reduce((prev, curr, i) => {
        if (i === 0) {
            return []
        }

        return [...prev, curr * i]
    }, [])
}

// Uses the fact that all things we care about happen in the first few seconds of these functions
export function findZero(polyZ, startTime) {
    const startPoint = getPoint(polyZ, startTime)
    let point = startPoint
    let prevTime = startTime
    let time = startTime

    if (point < 0) {
        // What does a ball starting underground mean? Probably my start time isn't quite right?
        // Assuming this case will never be a home run
        return time
    }

    while (point > 0 && point < 500) {
        prevTime = time
        time += 0.25 // 1 has run into an issue where you don't find the zero. 0.5 has always worked...so far. So make it 0.25
        point = getPoint(polyZ, time)
    }

    if (point > 0) {
        throw new Error('no negative value found for zero')
    }

    let newTime = time
    while (Math.abs(point) > 0.1) {
        newTime = (prevTime + time) / 2
        point = getPoint(polyZ, newTime)

        if (point > 0) {
            prevTime = newTime
        } else {
            time = newTime
        }
    }

    return newTime
}

// Perf: we could try avoiding sqrting here and compare squares instead
export function getGroundDistance([x, y]) {
    return Math.sqrt(x * x + y * y)
}

export function getBearing([x, y]) {
    // Todo: Handle fair/foul?
    return (Math.atan2(x, y) * 180) / Math.PI
}

export function getTimeData(polys, t) {
    // Naively done. Here's a spot to make more efficient
    const coords = polys.map((poly) => getPoint(poly, t))

    const distance = getGroundDistance(coords)
    const bearing = getBearing(coords)

    return {
        bearing,
        distance,
        coords,
        t,
    }
}

export function stretchPoly(poly, multiplier, fixedPoint) {
    return poly.map((val, i) => {
        if (i === 0) {
            return (val - fixedPoint) * multiplier + fixedPoint
        }
        return val * multiplier
    })
}
